<template>
  <div class="system-page auth-page">
    <section class="panel">
      <div class="panel-head">
        <div>
          <div class="panel-title">权限设置</div>
          <p class="panel-note head-note">为权限组勾选可访问的菜单。改当前登录角色后，左侧菜单会立即刷新。</p>
        </div>
        <div class="head-actions">
          <Button @click="getData">重置</Button>
          <Button color="primary" @click="save">保存</Button>
        </div>
      </div>

      <div class="auth-layout">
        <aside class="role-pane">
          <div class="pane-label">权限组</div>
          <div
            v-for="r of roles"
            :key="r.id"
            class="role-card"
            :class="{ selected: role && role.id === r.id }"
            @click="changeRole(r)"
          >
            <input
              class="role-name"
              v-model="r.name"
              :placeholder="'权限组名称'"
              @click.stop
              @blur="saveRoleName(r)"
              @keyup.enter="saveRoleName(r)"
            />
            <p class="role-desc">{{ r.description || '暂无说明' }}</p>
          </div>
        </aside>

        <div class="menu-pane">
          <div class="menu-head">
            <div class="pane-label">
              菜单权限
              <span v-if="role" class="pane-sub">{{ role.name }}</span>
            </div>
            <div>
              <Button
                size="s"
                color="primary"
                @click="
                  $refs.menu.chooseAll();
                  $refs.menu.expandAll();
                "
              >全选</Button>
              <Button size="s" @click="menus = []">清空</Button>
            </div>
          </div>
          <div class="menu-tree">
            <Tree :option="menuOption" multiple choose-mode="some" v-model="menus" ref="menu"></Tree>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { fullMenus, filterMenuKeys } from '@js/config/menu-config';
import Request from '@common/request';
import utils from '@common/utils';
import { message } from 'heyui';

export default {
  data() {
    return {
      role: null,
      roles: [],
      savedRoleNames: {},
      menuOption: {
        datas: fullMenus
      },
      menus: []
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getRoles();
      this.$nextTick(() => {
        if (this.$refs.menu) {
          this.$refs.menu.expandAll();
        }
      });
    },
    changeRole(r) {
      this.role = r;
      this.getData(r);
    },
    getRoles() {
      const currentId = this.role ? this.role.id : null;
      Request.Management.roles().then((resp) => {
        if (resp.ok) {
          this.roles = resp.body || [];
          this.savedRoleNames = {};
          this.roles.forEach((item) => {
            this.savedRoleNames[item.id] = item.name;
          });
          const keep = this.roles.find((item) => item.id === currentId);
          this.role = keep || this.roles[0] || null;
          if (this.role) {
            this.getData();
          }
        }
      });
    },
    saveRoleName(item) {
      const name = String(item.name || '').trim();
      if (!name) {
        message.error('权限组名称不能为空');
        item.name = this.savedRoleNames[item.id] || item.name;
        return;
      }
      if (name === this.savedRoleNames[item.id]) {
        item.name = name;
        return;
      }
      Request.Management.updateRole(item.id, { name }).then((resp) => {
        if (!resp.ok) {
          message.error(resp._msg || '修改名称失败');
          item.name = this.savedRoleNames[item.id] || item.name;
          return;
        }
        item.name = resp.body.name;
        this.savedRoleNames[item.id] = resp.body.name;
        if (this.role && this.role.id === item.id) {
          this.role.name = resp.body.name;
        }
        message.success('权限组名称已更新');
      });
    },
    getData() {
      if (!this.role) {
        return;
      }
      Request.Account.getRoleConfig(this.role.id).then((resp) => {
        if (resp.ok) {
          this.menus = resp.body.menus || [];
        }
      });
    },
    save() {
      Request.Account.saveRoleConfig({
        roleId: this.role.id,
        menus: this.menus,
        users: []
      }).then((resp) => {
        if (!resp.ok) {
          message.error(resp._msg || '保存失败');
          return;
        }
        message.success('保存成功');
        const currentRoleId = Number(this.$store.state.user?.role_id);
        if (currentRoleId === Number(this.role.id)) {
          Request.Account.menus().then((menuResp) => {
            if (menuResp.ok && menuResp.body && Array.isArray(menuResp.body.menus)) {
              const menuKeys = filterMenuKeys(menuResp.body.menus);
              this.$store.dispatch('updateMenuKeys', menuKeys);
              utils.saveLocal('SYS_USER_MENUS', menuKeys);
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import '@/views/system/system-pages.less';

.auth-page {
  max-width: 1100px;
}

.panel-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.head-note {
  margin-top: 6px;
}

.head-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.auth-layout {
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 20px;
  min-height: 520px;
  margin-top: 8px;
}

.pane-label {
  font-size: 13px;
  font-weight: 600;
  color: @app-text;
  margin-bottom: 12px;
}

.pane-sub {
  margin-left: 8px;
  font-weight: 400;
  color: @app-primary;
}

.role-card {
  padding: 14px 14px 12px;
  margin-bottom: 10px;
  border: 1px solid @app-border;
  border-radius: 8px;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    border-color: #d7e6fb;
    background: #fafcff;
  }

  &.selected {
    border-color: @app-primary;
    background: @app-primary-light;
    box-shadow: 0 0 0 3px rgba(55, 136, 238, 0.08);
  }
}

.role-name {
  width: 100%;
  border: none;
  border-bottom: 1px solid transparent;
  background: transparent;
  padding: 0 0 4px;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  color: @app-text;
  outline: none;

  &:focus {
    border-bottom-color: @app-primary;
  }
}

.role-desc {
  margin: 6px 0 0;
  font-size: 12px;
  line-height: 1.6;
  color: @app-muted;
}

.menu-pane {
  display: flex;
  flex-direction: column;
  min-width: 0;
  border: 1px solid @app-border;
  border-radius: 8px;
  padding: 16px 18px;
  background: #fafbfc;
}

.menu-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;

  .pane-label {
    margin-bottom: 0;
  }
}

.menu-tree {
  flex: 1;
  overflow: auto;
  padding: 10px 12px;
  background: #fff;
  border: 1px solid @app-border;
  border-radius: 6px;

  :deep(.h-tree-item) {
    padding: 3px 0;
  }
}

@media (max-width: 860px) {
  .auth-layout {
    grid-template-columns: 1fr;
  }
}
</style>
